'use strict';

class WarningModal {
    constructor() {
    }

    openModal() {
        M.Modal.getInstance($('#warningModal')).open();
    }
}
export default WarningModal;